import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {
    transform(value: number): string {
        if (!value || value <= 0) {
            return '0s'; // Default value for invalid or zero duration
        }

        const totalSeconds = Math.floor(value); // Ensure duration is an integer
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const hoursStr = hours > 0 ? `${hours}h ` : '';
        const minutesStr = minutes > 0 ? `${minutes}m ` : '';
        const secondsStr = `${seconds}s`;

        return `${hoursStr}${minutesStr}${secondsStr}`.trim();
    }
}
